import {memo} from "react";
import {Button, ButtonProps} from "../../../ui/button";
import {Icon} from "@chakra-ui/react";
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import {MenuContent, MenuItem, MenuRoot, MenuTrigger} from "../../../ui/menu";
import {FilterOperator} from "../../../../hooks/filter/filterState";
import T from "platformed-components/i18n/T";

export const MatchFiltersButton = memo(
  ({
    operator,
    onChangeOperator,
    ...props
  }: {operator: FilterOperator; onChangeOperator: (operator: FilterOperator) => void} & ButtonProps) => {
    return (
      <MenuRoot onSelect={d => onChangeOperator(d.value as FilterOperator)}>
        <MenuTrigger asChild>
          <Button size="xs" colorPalette="blue" variant="ghost" {...props}>
            {operator === "all" ? <T keyName="c.Match_all" /> : <T keyName="c.Match_any" />}
            <Icon>
              <ChevronDownIcon />
            </Icon>
          </Button>
        </MenuTrigger>
        <MenuContent>
          <MenuItem value="all">
            <T keyName="c.Match_all" />
          </MenuItem>
          <MenuItem value="any">
            <T keyName="c.Match_any" />
          </MenuItem>
        </MenuContent>
      </MenuRoot>
    );
  },
);
